<template>
  <div :style="styles.wrapper">
    <LibraryGrid fullWidth>
      <div class="view-explanation">
        <button class="toggle-cards button__action button__delete" @click="toggleDeleted()">{{showDeleted ? 'View Active Sequences' : 'View Deleted Sequences'}}</button>
        <h1>Sequences</h1>
        <p>Sequences are a group of
          <router-link to="/cards">action cards</router-link> set in a certain order. Sequences may be assigned to a
          <router-link to="/policies">policy</router-link>, and when the rules of that policy are met by a user of the app, the designated sequence will deliver its action cards.
        </p>
      </div>
      <section
        v-if="showDeleted ? sequence.deleted : !sequence.deleted"
        v-for="sequence in getSequences"
        :style="styles.cardWrap"
        @click="goToSequence(sequence._id)"
      >
        <div :style="styles.cardContainer">
          <p :style="styles.cardName">Sequence</p>
          <p>{{sequence.name}}</p>
        </div>
        <i :style="styles.backIcon" class="glyphicon glyphicon-chevron-right"></i>
      </section>
      <section :style="styles.cardWrap" @click="createNewSequence()" v-if="!showDeleted">
        <div :style="styles.cardContainer">
          <p :style="styles.cardName">Sequence</p>
          <p>Create New Sequence</p>
        </div>
        <i :style="styles.backIcon" class="glyphicon glyphicon-chevron-right"></i>
      </section>
    </LibraryGrid>
  </div>
</template>

<script>
import LibraryGrid from "../general/LibraryGrid";
import Services from "../../services/Services";
import store from "../../store";
export default {
  name: "sequenceLibrary",
  components: {
    LibraryGrid
  },
  computed: {
    getSequences() {
      return store.getters.getSequences;
    }
  },
  data() {
    return {
    showDeleted: false,
      query: "",
      styles: {
        wrapper: {
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          height: "100vh",
          boxSizing: "border-box"
        },
        nav: {
          position: "fixed",
          top: "0",
          left: "200",
          right: "0",
          background: "#fff",
          boxShadow: "0 2px 5px 1px rgba(0,0,0,0.1)",
          height: "60px",
          zIndex: "99",
          padding: "10",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        navInputWrapper: {
          flex: "0 0 auto",
          width: "250px",
          padding: "10",
          background: "#f5f5f5",
          border: "1px solid #eee",
          borderRadius: "5",
          overflow: "hidden",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        navInput: {
          flex: "1",
          padding: "0",
          borderRadius: "0",
          border: "0",
          background: "#f5f5f5"
        },
        navInputIcon: {
          margin: "auto 10px auto 0",
          color: "#888",
          fontSize: "1.25em"
        },
        toggleUploadModalButton: {
          background: "#09a3ed",
          fontSize: "0.9em",
          color: "#fff",
          borderRadius: "5px",
          padding: "5px 10px 5px 5px",
          margin: "auto 0 auto auto",
          border: "0",
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center"
        },
        cardWrap: {
          background: "#fff",
          display: "flex",
          border: "1px solid #eee",
          cursor: "pointer",
          padding: "0 10px",
          flexFlow: "row nowrap",
          width: "calc(33.33% - 20px)",
          margin: "10px"
        },
        cardContainer: {
          display: "flex",
          flexFlow: "column nowrap"
        },
        cardPreview: {
          background: "teal",
          position: "relative",
          padding: "20"
        },
        cardName: {
          color: "#aaa",
          fontSize: "0.9em",
          marginBottom: "0"
        },
        cardMetadataSection: {
          display: "flex",
          flexFlow: "column nowrap",
          padding: "40",
          width: "100%"
        },
        cardType: {
          margin: "20px auto 10px 20px",
          color: "#888"
        },
        backIcon: {
          margin: "auto 5px auto auto",
          color: "#aaa"
        },
        actionType: {
          margin: "0 auto 20px 20px",
          fontSize: "1.5em"
        },
        tabWrap: {
          width: "100%",
          minHeight: "200",
          margin: "0",
          display: "flex",
          background: "#e8ffff",
          flexFlow: "column nowrap"
        },
        tabList: {
          listStyle: "none",
          display: "flex",
          flexFlow: "row nowrap",
          margin: "0",
          padding: "0"
        },
        tab: {
          flex: "1",
          padding: "10",
          borderBottom: "5px solid #fff",
          textAlign: "center"
        }
      }
    };
  },
  methods: {
      toggleDeleted(){
        this.showDeleted = !this.showDeleted;
      },
    goToSequence(id) {
      this.$router.push("/sequences/" + id);
    },
    createNewSequence() {
      let newSequence = {
        name: "",
        actionCards: [],
        templates: []
      };

      Services.setActiveSequence(newSequence);
      this.$router.push("/sequences/create");
    }
  },
  mounted() {
    Services.getSequences();
    Services.clearActiveSequence();
  }
};
</script>
<style lang="scss" scoped>
.toggle-cards {

    @media all and (min-width:641px){
        right: 2rem;
        top: 6rem;
        position: absolute;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/SequenceLibrary.vue